import { GetServerSidePropsContext } from './models';

/** Проверяем заголовки для определения авторизованной зоны */
export const isAuthServerRequests = ({
  authZoneHeaderName,
  context,
}: {
  context: GetServerSidePropsContext;
  authZoneHeaderName: string;
}) => {
  return context.req?.headers[authZoneHeaderName] === '1';
};
